import * as React from "react";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CodeEditor } from "../../group/identityMatcher/codeEditor";
import { formSet, formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { store } from "../../../store";
import { ImportButtonRaw, DropZone } from "../../../components/import";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { SecretCodeEditorObfuscated } from "./SecretCodeEditorObfuscated";

interface Props {}
export const SecretDataGCP: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const value = useCpFormValue(`gcp`);

  return (
    <>
      <CardContent>
        <div className="flex items-center gap-4 mb-2">
          <div>GCP Secret Data</div>
          <ImportButtonRaw
            formId={id}
            fieldName="gcp"
            actionLabel="Import GCP secret"
            accept=".json"
            existingHasContent={!!value?.trim()}
            explanation={
              <div className="text-xs">
                <div className="font-semibold mb-1">Accepted format:</div>
                <div><strong>.json</strong> — GCP service account key</div>
                <div className="mt-1 opacity-75">Downloaded from GCP Console › IAM › Service Accounts</div>
              </div>
            }
          />
        </div>
        <SecretCodeEditorObfuscated visibilityName="meta.codeEditorVisibility.gcp" contentName="gcp">
          <DropZone
            formId={id}
            fieldName="gcp"
            actionLabel="Import GCP secret"
            accept={[".json"]}
          >
            <CodeEditor
              value={value}
              setValue={(value) => {
                formSetValue(id, `gcp`, value);
              }}
              onChange={() => {
                const name = "gcp";
                formSet(id, `fieldStates.${name}.modified`, true);

                const form = store.getState().form.instances[id];
                const onChangeCounter = form.meta.onChangeCounter;
                formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
              }}
              onFocus={() => {
                const name = "gcp";
                formSet(id, `fieldStates.${name}.focused`, true);
                formSet(id, `fieldStates.${name}.visited`, true);
              }}
              onBlur={() => {
                const name = "gcp";
                formSet(id, `fieldStates.${name}.focused`, false);
                formSet(id, `fieldStates.${name}.touched`, true);

                const form = store.getState().form.instances[id];
                const onBlurCounter = form.meta.onBlurCounter;
                formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
              }}
              language={"javascript"}
              options={{
                basicSetup: {
                  lineNumbers: true,
                },
                style: {
                  maxHeight: 500,
                  overflow: "auto",
                  fontSize: 14,
                },
              }}
            />
          </DropZone>
        </SecretCodeEditorObfuscated>
        <CpErrorWarning name={`gcp`} />
      </CardContent>
    </>
  );
};
